import React from 'react';
import { createRoot } from 'react-dom/client';
import ReactDOM from 'react-dom';
import App from './components/App';
import { VistaprintAuth } from '@vp/auth-react';
import './i18n';

if (process.env.NODE_ENV !== 'production') {
  const axe = require('@axe-core/react');
  const axeConfig = {
    rules: [
      {
        id: 'duplicate-id',
        enabled: false,
      },
      {
        id: 'html-lang-valid',
        enabled: false,
      },
      {
        id: 'link-name',
        enabled: false,
      },
      {
        id: 'aria-allowed-role',
        enabled: false,
      },
      {
        id: 'aria-valid-attr-value',
        enabled: false,
      },
      {
        id: 'empty-heading',
        enabled: false,
      },
      {
        id: 'region',
        enabled: false,
      },
      {
        id: 'page-has-heading-one',
        enabled: false,
      },
    ],
  };
  axe(React, ReactDOM, 1000, axeConfig);
}
const urlSearchParams: any = new URLSearchParams(window.location.search);
const params = Object.fromEntries(urlSearchParams.entries());
const isCareAgent = params.care_agent;
const redirectionInProgress = params.code && params.state;
let config;
if (isCareAgent) {
  window.localStorage.setItem('isCareAgent', 'true');
}
if (window.localStorage.getItem('isCareAgent')) {
  config = {
    developmentMode: {
      clientID: window.vbcConfig.careConsoleClientId,
      redirectUriOrigin: `${window.location.origin}/${window.csbData.culture}/studio`,
    },
    options: {
      connection: 'vista-okta',
    },
    enableCrossSiteSso: true,
    culture: 'en-US',
  };
} else {
  config = {
    culture: window.csbData.culture,
    developmentMode:
      window.vbcConfig.env === 'production'
        ? false
        : {
            domain: 'oauth.cimpress.io',
            redirectUriOrigin: `${window.location.origin}${window.location.pathname}`,
          },
  };
}
VistaprintAuth.init(config).then((identity) => {
  if (identity.isSignedIn) {
    window.localStorage.removeItem('isCareAgent');
  }
  if (
    window.localStorage.getItem('isCareAgent') &&
    !identity.isSignedIn &&
    !redirectionInProgress
  ) {
    // @ts-ignore
    const auth = new VistaprintAuth.WebAuth();
    auth.signIn();
  } else {
    createRoot(document.getElementById('root')!).render(<App />);
  }
});
